import React from 'react';

import { connect } from "react-redux";
import { changeFilter, changeDatalist, changeMutex, changeValues } from "../../redux/actions";
import { pageDistintaSelector } from "../../redux/selectors";

import BaseClass from '../common/baseClass';
import LoaderView from './loader';

import DistintaStatusBar from '../Distinta/statusBar';
import PartsList from '../Distinta/partsList';
import ImgTavola from '../Distinta/imgTavola';

import '../../css/page-body.css';
import '../../css/print.css';

class PageDistinta extends BaseClass {
  componentWillMount(props) {
    this.updateStateWithStoreProps();
  }

  componentWillReceiveProps(nextprops) {
    this.updateStateWithStoreProps(nextprops);
  }

  componentDidUpdate(nextProps) {
    this.updateStateWithStoreProps(nextProps)
  }

  render(){
    const $ = window.$;
    /*if(!this.state.renewMutex.mostraImg){
      $("body").css("overflow", "hidden");
    }
    else{
      $("body").css("overflow", "auto");
    }*/
    return (
      <>
        {!this.state.renewMutex.mostraImg ?
          <LoaderView></LoaderView>
          :
          ""
        }
        <div className="noStampa pageDistinta mb-4 pt-4">
          <DistintaStatusBar></DistintaStatusBar>
          <div className="distintaContainer row mt-2">
            <PartsList></PartsList>
            <ImgTavola></ImgTavola>
          </div>
        </div>

      </>
    )
  }
}


const mapStateToProps = state => {
  const store = pageDistintaSelector(state);
  return { store };
}
export default connect(mapStateToProps, {changeFilter, changeDatalist, changeMutex, changeValues})(PageDistinta);
//export default PageDistinta;
